export enum SPECS {
  ENABLE_LOST_BUSINESS_EMAIL = 'specs.stores.EnableLostBusinessEmail',
  SUBSCRIPTION_PLANS = 'specs.stores.ProductSubscriptionsSF',
  SUPPORT_ALT_TEXT = 'specs.stores.SupportAltTextInImages',
}
